parseTokenYYYY